import * as React from 'react'

function TrashWhiteIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" {...props}>
      <g fill="none" stroke="#263238" strokeWidth={1}>
        <rect width={48} height={48} rx={4} stroke="none" />
      </g>
      <g
        data-name="Group 52939"
        transform="translate(-919.942 -376.811)"
        fill="none"
        stroke="#263238"
        strokeWidth={1.4}
      >
        <path data-name="Path 12831" d="M941.281 395.52a3.2 3.2 0 016.322 0" strokeLinejoin="round" />
        <path data-name="Path 12832" d="M937.318 396.258v13.553h14.248v-13.553" />
        <path data-name="Line 330" transform="translate(934.942 396.005)" d="M0 0L19 0" />
        <path data-name="Line 421" transform="translate(941.117 400.962)" d="M0 0L0 5.234" />
      </g>
    </svg>
  )
}

export default TrashWhiteIcon
